import React from 'react';
import { BinocularsIcon, FileIcon, NotePencilIcon, TruckIcon } from '@fronton/icons-react';
import {
  ButtonWithGAClickButton,
  LinkWithGAClickButton,
  ReviewsBenefits,
  ReviewsCatalog,
  ReviewsSection,
  Typography,
} from 'common/components';
import { fullWidthMobileutton } from 'common/styles/common';
import {
  newKitchenReviewsBenefitsLink,
  newKitchenReviewsLink,
} from './new-kitchen-reviews-styles';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';
import { NEW_KITCHEN_REVIEWS_DATA } from './new-kitchen-reviews-constants';

type NewKitchenReviewsProps = {
  experimentCookie: string;
  signUpHref: string;
};

const BenefitsLink = ({ signUpHref }: { signUpHref: string }) => (
  <>
    <span>Сделаем</span>{'\n'}
    <LinkWithGAClickButton
      className={newKitchenReviewsBenefitsLink}
      elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
      elementName="Отзывы клиентов"
      elementText="Запишитесь"
      title="Запишитесь на проектирование"
      href={signUpHref}
      target="_blank">
      <Typography variant="m" size="body_long" color="text-invert">
        точный замер
      </Typography>
    </LinkWithGAClickButton>{' '}
  </>
);

export const NewKitchenReviews: React.FC<NewKitchenReviewsProps> = ({ experimentCookie, signUpHref }) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits
        benefitsList={[
          {
            icon: NotePencilIcon,
            text: experimentCookie === 'A' ? 'Сделаем\nточный замер' : <BenefitsLink signUpHref={signUpHref} />,
          },
          {
            icon: FileIcon,
            text: 'Подготовим\nдизайн-проект',
          },
          {
            icon: BinocularsIcon,
            text: 'Подберём\nнеобходимую технику',
          },
          {
            icon: TruckIcon,
            text: 'Доставим\nи\u00A0соберём кухню',
          },
        ]}
        newVariant
      />
    }
    description="Делаем кухни, которые хочется показывать"
    review={
      <ReviewsCatalog
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        newVariant={experimentCookie !== 'A'}
        reviewsList={NEW_KITCHEN_REVIEWS_DATA}
        modalButton={
          <ButtonWithGAClickButton
            className={fullWidthMobileutton}
            elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
            elementName="Отзывы клиентов"
            elementText="Запишитесь"
            title="Запишитесь на проектирование"
            href={signUpHref}
            target="_blank"
            variant="accent"
            wide
          >
            Записаться на проектирование
          </ButtonWithGAClickButton>
        }
      />
    }
    title={<>
      <LinkWithGAClickButton
        className={newKitchenReviewsLink}
        elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
        elementName="Отзывы клиентов"
        elementText="Запишитесь"
        title="Запишитесь на проектирование"
        href={signUpHref}
        target="_blank">
        <Typography variant="h2" color="text-invert">
          Запишитесь
        </Typography>
      </LinkWithGAClickButton>{' '}
      на&nbsp;бесплатное проектирование, <span>а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах!</span>
    </>
    }
  />
);
